'use strict';

var util = require('../util');

/*
 * In helpcentre heading description text is shrinked for mobile views
 * with the posibillity of expanding on "read more" click
 */
function manageHeadDescriptionText () {
	var helpCentreDescription = $('.help-centre-description'),
		readMoreButton = helpCentreDescription.find('.read-more'),
		descriptionText = helpCentreDescription.find('.text');

	// set the initial state
	$(window).on('resize', function () {
		if (util.viewport.isMobile()) {
			readMoreButton.css('display', 'block');
			descriptionText.css('display', '-webkit-box');
		} else {
			readMoreButton.css('display', 'none');
			descriptionText.css('display', 'block');
		}
	});

	readMoreButton.on('click', function () {
		descriptionText.css('display', 'block');
		$(this).hide();
	});
}

/*
 * In top faq section on click of the "read more" link in the short answer
 * find the needed detailed answer in accordion and scroll to it
 */
function processTopQuestionAnswerClick () {
	$('.faq-main-points .read-more-link').on('click', function () {
		var linkName = $(this).attr('name');
		var accordionPoint = $('.faq-accordion a[name=' + linkName + ']');
		var pointlabel = accordionPoint.parent().prev();

		// expand the corresponding accordion tab if it's closed
		if (pointlabel.hasClass('ui-accordion-header-collapsed')) {
			pointlabel.trigger('click');
		}

		// wait for the tab with the answer to open and scroll to it
		setTimeout(function () {
			var pointOffset = pointlabel.offset().top;
			window.scrollTo({
				top: pointOffset,
				behavior: 'smooth'
			});
		}, 300);
	});
}

exports.init = function () {
	manageHeadDescriptionText();
	processTopQuestionAnswerClick();
};
